import React, { useState } from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import AppointmentModal from "../Components/AppointmentModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import profile1 from "../Assets/profile-1.png";
import profile2 from "../Assets/profile-2.png";
import "../Styles/AboutPage.css";
function About() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => {
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  return (
    <div className="about-page">
      <Navbar />
      {/* Hero Section */}
      <section className="about-hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <div className="hero-badge">
            <span>About NeuroCare Clinic</span>
          </div>
          <h1 className="hero-title">
            Leading the Future of
            <span className="hero-highlight"> Neurological Care</span>
          </h1>
          <p className="hero-description">
            For over 15 years, NeuroCare Clinic has been at the forefront of neurological healthcare,
            combining cutting-edge medical technology with compassionate, patient-centered care to
            improve lives and advance neurological treatment standards.
          </p>
          <div className="hero-stats" />
        </div>
        <div className="hero-shape">
          <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <circle cx="50" cy="50" r="40" fill="rgba(255,255,255,0.1)"/>
            <circle cx="50" cy="50" r="25" fill="rgba(255,255,255,0.05)"/>
          </svg>
        </div>
      </section>

      {/* Our Story Section */}
      <section className="story-section">
        <div className="story-container">
          <div className="story-content">
            <div className="story-text">
              <h2 className="section-title">Our Story</h2>
              <p className="story-description">
                Founded in 2008 by Dr. Sarah Mitchell, a renowned neurologist with over 20 years of experience,
                NeuroCare Clinic began as a vision to revolutionize neurological care. What started as a small
                practice has grown into one of the most trusted neurological centers in the region.
              </p>
              <p className="story-description">
                Our journey has been marked by continuous innovation, from pioneering telemedicine services
                to implementing state-of-the-art diagnostic equipment. We've remained committed to our
                founding principles: excellence in patient care, medical innovation, and community service.
              </p>
              <div className="story-highlights">
                <div className="highlight-item">
                  <div className="highlight-icon">🏆</div>
                  <div className="highlight-text">
                    <h4>Award-Winning Care</h4>
                    <p>Recognized nationally for excellence in neurological treatment</p>
                  </div>
                </div>
                <div className="highlight-item">
                  <div className="highlight-icon">🔬</div>
                  <div className="highlight-text">
                    <h4>Research & Innovation</h4>
                    <p>Active participation in clinical trials and medical research</p>
                  </div>
                </div>
                <div className="highlight-item">
                  <div className="highlight-icon">🤝</div>
                  <div className="highlight-text">
                    <h4>Community Focus</h4>
                    <p>Dedicated to serving our local community with compassion</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="story-image">
              <div className="image-placeholder">
                <span>🏥</span>
                <p>NeuroCare Clinic Building</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision Section */}
      <section className="mission-section">
        <div className="mission-container">
          <div className="mission-intro">
            <h2 className="section-main-title">Our Mission & Vision</h2>
            <p className="section-description">
              Driving excellence in neurological healthcare through innovation, compassion, and unwavering commitment to patient well-being.
            </p>
          </div>

          <div className="mission-grid">
            <div className="mission-card">
              <div className="card-icon">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2M21.5 12.5C21.5 13.33 20.83 14 20 14C19.17 14 18.5 13.33 18.5 12.5C18.5 11.67 19.17 11 20 11C20.83 11 21.5 11.67 21.5 12.5M18.5 18.5C18.5 19.33 17.83 20 17 20C16.17 20 15.5 19.33 15.5 18.5C15.5 17.67 16.17 17 17 17C17.83 17 18.5 17.67 18.5 18.5M15.5 6.5C15.5 7.33 14.83 8 14 8C13.17 8 12.5 7.33 12.5 6.5C12.5 5.67 13.17 5 14 5C14.83 5 15.5 5.67 15.5 6.5Z"/>
                </svg>
              </div>
              <h3 className="card-title">Our Mission</h3>
              <p className="card-description">
                To provide exceptional neurological care that improves quality of life, advances medical
                knowledge, and serves our community with integrity and compassion.
              </p>
            </div>

            <div className="mission-card">
              <div className="card-icon">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2ZM21 9V7L15 1H5C3.89 1 3 1.89 3 3V21C3 22.11 3.89 23 5 23H19C20.11 23 21 22.11 21 21V9M19 9H14V4H19V9M12 11C13.66 11 15 12.34 15 14C15 15.66 13.66 17 12 17C10.34 17 9 15.66 9 14C9 12.34 10.34 11 12 11Z"/>
                </svg>
              </div>
              <h3 className="card-title">Our Vision</h3>
              <p className="card-description">
                To be the leading neurological healthcare provider, recognized globally for innovation,
                excellence in patient care, and contributions to neurological research.
              </p>
            </div>

            <div className="mission-card">
              <div className="card-icon">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2M12 6.5L10.91 9.74L8 9L10.91 8.26L12 6.5M12 6.5L13.09 8.26L16 9L13.09 9.74L12 6.5M12 13.5L10.91 9.74L8 9L10.91 8.26L12 13.5M12 13.5L13.09 9.74L16 9L13.09 8.26L12 13.5Z"/>
                </svg>
              </div>
              <h3 className="card-title">Our Values</h3>
              <ul className="values-list">
                <li><span className="bullet">•</span>Patient-centered care above all</li>
                <li><span className="bullet">•</span>Medical excellence and innovation</li>
                <li><span className="bullet">•</span>Integrity and ethical practice</li>
                <li><span className="bullet">•</span>Compassion and empathy</li>
                <li><span className="bullet">•</span>Continuous learning and improvement</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="team-section">
        <div className="team-container">
          <div className="section-intro">
            <h2 className="section-main-title">Meet Our Expert Team</h2>
            <p className="section-description">
              Our multidisciplinary team of specialists brings together decades of experience and expertise
              in neurological care, working together to provide comprehensive treatment solutions.
            </p>
          </div>

          <div className="team-grid">
            <div className="team-member">
              <div className="member-image">
                <img src={profile1} alt="Dr. Bagadi Suneel Kumar" />
              </div>
              <h3 className="member-name">Dr. Bagadi Suneel Kumar</h3>
              <p className="member-title">Neuro Physician</p>
              <p className="member-description">
                M.D, D.M.(NIMS) Neuro Physician For Headache, Seizures, Paralysis, Muscle & Nerve Disorders
              </p>
              <div className="member-rating">
                <FontAwesomeIcon icon={faStar} style={{ color: "#F7BB50", marginRight: "6px" }} />
                <strong>4.9</strong>
                <span className="member-reviews"> (1,800+)</span>
              </div>
            </div>

            <div className="team-member">
              <div className="member-image">
                <img src={profile2} alt="Dr. Pydi Venu Madhavi" />
              </div>
              <h3 className="member-name">Dr. Pydi Venu Madhavi</h3>
              <p className="member-title">Endocrinologist</p>
              <p className="member-description">
                M.D(General Medicine), D.M. Endocrinology (osm) for diabetes, thyroids, pcos, growth & hormonal problem
              </p>
              <div className="member-rating">
                <FontAwesomeIcon icon={faStar} style={{ color: "#F7BB50", marginRight: "6px" }} />
                <strong>4.7</strong>
                <span className="member-reviews"> (450+)</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Facilities Section */}
      <section className="facilities-section">
        <div className="facilities-container">
          <div className="section-intro">
            <h2 className="section-main-title">State-of-the-Art Facilities</h2>
            <p className="section-description">
              Our modern facility is equipped with the latest diagnostic and treatment technology,
              ensuring accurate diagnoses and effective treatments in a comfortable environment.
            </p>
          </div>

          <div className="facilities-grid">
            <div className="facility-item">
              <div className="facility-icon">🧠</div>
              <h3 className="facility-title">Advanced MRI Suite</h3>
              <p className="facility-description">
                3T MRI scanner for detailed brain and nervous system imaging with rapid, comfortable scanning.
              </p>
            </div>

            <div className="facility-item">
              <div className="facility-icon">⚡</div>
              <h3 className="facility-title">EEG Laboratory</h3>
              <p className="facility-description">
                State-of-the-art electroencephalography equipment for accurate seizure and epilepsy diagnosis.
              </p>
            </div>

            <div className="facility-item">
              <div className="facility-icon">🏃‍♂️</div>
              <h3 className="facility-title">Rehabilitation Center</h3>
              <p className="facility-description">
                Comprehensive physiotherapy and rehabilitation facilities with modern equipment and expert therapists.
              </p>
            </div>

            <div className="facility-item">
              <div className="facility-icon">💻</div>
              <h3 className="facility-title">Telemedicine Suite</h3>
              <p className="facility-description">
                Advanced video consultation rooms for remote neurological care and follow-up appointments.
              </p>
            </div>

            <div className="facility-item">
              <div className="facility-icon">🔬</div>
              <h3 className="facility-title">Research Laboratory</h3>
              <p className="facility-description">
                Dedicated research facility for clinical trials and neurological research studies.
              </p>
            </div>

            <div className="facility-item">
              <div className="facility-icon">🏥</div>
              <h3 className="facility-title">Emergency Department</h3>
              <p className="facility-description">
                24/7 emergency neurological care with rapid response capabilities for critical situations.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Achievements Section */}
      <section className="achievements-section">
        <div className="achievements-container">
          <div className="section-intro">
            <h2 className="section-main-title">Our Achievements</h2>
            <p className="section-description">
              Recognition and milestones that reflect our commitment to excellence in neurological healthcare.
            </p>
          </div>

          <div className="achievements-grid">
            <div className="achievement-card">
              <div className="achievement-number">15+</div>
              <div className="achievement-text">
                <h3>Years of Service</h3>
                <p>Providing exceptional neurological care since 2008</p>
              </div>
            </div>

            <div className="achievement-card">
              <div className="achievement-number">50K+</div>
              <div className="achievement-text">
                <h3>Patients Treated</h3>
                <p>Successfully treated over 50,000 patients with various neurological conditions</p>
              </div>
            </div>

            <div className="achievement-card">
              <div className="achievement-number">98%</div>
              <div className="achievement-text">
                <h3>Patient Satisfaction</h3>
                <p>Exceptional patient satisfaction rating across all services</p>
              </div>
            </div>

            <div className="achievement-card">
              <div className="achievement-number">25+</div>
              <div className="achievement-text">
                <h3>Research Publications</h3>
                <p>Published research papers in leading neurological journals</p>
              </div>
            </div>

            <div className="achievement-card">
              <div className="achievement-number">5</div>
              <div className="achievement-text">
                <h3>Awards Won</h3>
                <p>National and regional awards for healthcare excellence</p>
              </div>
            </div>

            <div className="achievement-card">
              <div className="achievement-number">100%</div>
              <div className="achievement-text">
                <h3>Board Certified</h3>
                <p>All our neurologists are board-certified specialists</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-container">
          <h2 className="cta-title">Experience Excellence in Neurological Care</h2>
          <p className="cta-description">
            Join thousands of patients who trust NeuroCare Clinic for their neurological healthcare needs.
            Schedule your consultation today and take the first step towards better neurological health.
          </p>
          <div className="cta-buttons">
            <button onClick={openModal} className="cta-primary-btn">
              Schedule Consultation
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6L16 12 10 18 8.59 16.59Z"/>
              </svg>
            </button>
            <a href="/contact" className="cta-secondary-btn">
              Contact Us
            </a>
          </div>
        </div>
      </section>

      <Footer />

      <AppointmentModal isOpen={isModalOpen} onClose={closeModal} />
    </div>
  );
}

export default About;
